import StorageHelper from './StorageHelper';

export default new StorageHelper(window.localStorage);



// WEBPACK FOOTER //
// ./src/utils/LocalStorageHelper.js